<template>
  <div class="settings-preference-table-entry">
    <label>
      {{ label }}
    </label>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'SettingsPreferenceTableEntry',
  props: {
    label: String,
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.settings-preference-table-entry {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0.75rem;

  &:not(:last-child) {
    border-bottom: 0.0625rem solid $background;
  }

  label {
    margin: 0 0.5rem;
  }
}
</style>
